@if (isCandidate()) {
  <rt-dropdown>
    <rt-dropdown-header>
      {{ 'rtu.common.candidate' | translate }}
    </rt-dropdown-header>
    <rt-dropdown-item class="info-item" layout layout-vertical>
      <div class="info-wrap" layout layout-align-items-center>
        <rt-avatar
          [type]="tag.candidate!.hasAvatar ? 'image' : 'initials'"
          [initials]="tag.candidate!.initials"
          [size]="'base'"
          [shape]="'oval'"
          [imageSrc]="tag.candidate!.photoThumbUrl"
        >
        </rt-avatar>
        <div class="text-wrap" layout layout-vertical>
          <rt-heading>
            {{ tag.candidate!.name }}
          </rt-heading>
          @if (tag.candidate!.placements && tag.candidate!.placements.length) {
            <div class="text" layout>
              @if (tag.candidate!.placements[0].offer) {
                <span>
                  {{ tag.candidate!.placements[0].offer.title }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </rt-dropdown-item>
    <rt-dropdown-header [isSubheading]="true">
      {{ 'rtu.mailbox.send_mail_to' | translate }}
    </rt-dropdown-header>

    @if (tag.candidate!.emails.length) {
      @for (email of getAllEmailsFromTag(); track trackByEmail($index, email)) {
        <rt-dropdown-item (click)="select(email)">
          <div class="item-content-email" [style.max-width]="'80%'">
            <rt-truncate>{{ email }}</rt-truncate>
          </div>

          @if (isEmailActive(email)) {
            <rt-icon
              prefix
              name="check"
              size="medium"
              colorToken="colorIconPrimaryDefault"
            ></rt-icon>
          }
        </rt-dropdown-item>
      }
    }
    @if (!tag.candidate!.emails.length && tag.email) {
      <rt-dropdown-item>
        <div class="item-content-email" [style.max-width]="'80%'">
          <rt-truncate>{{ tag.email }}</rt-truncate>
        </div>

        <rt-icon prefix name="check" size="medium" colorToken="colorIconPrimaryDefault"> </rt-icon>
      </rt-dropdown-item>
    }
    <rt-dropdown-item (click)="showCandidate()">
      {{ 'rtu.mailbox.go_to_profile' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
}

@if (isAdmin()) {
  <rt-dropdown>
    <rt-dropdown-header>
      {{ 'rtu.common.team_member' | translate }}
    </rt-dropdown-header>
    <rt-dropdown-item class="info-item" layout layout-vertical>
      <rt-avatar
        prefix
        [type]="tag.admin!.hasAvatar ? 'image' : 'initials'"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="tag.admin!.photoThumbUrl"
        [initials]="tag.admin!.initials"
      >
      </rt-avatar>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>{{ tag.name }}</rt-heading>
        <div class="text" layout>
          <span>{{ tag.email }}</span>
        </div>
      </div>
    </rt-dropdown-item>
  </rt-dropdown>
}

@if (!isCandidate() && !isAdmin()) {
  <rt-dropdown>
    <rt-dropdown-item class="info-item" layout layout-vertical>
      <div class="info-wrap" layout layout-align-items-center>
        <div class="text-wrap" layout layout-vertical>
          <rt-heading>{{ tag.name }}</rt-heading>
          <div class="text" layout>
            <span>{{ tag.email }}</span>
          </div>
        </div>
      </div>
    </rt-dropdown-item>
  </rt-dropdown>
}
